import { FC } from 'react';
import Modal, { ModalContent } from '../../Modal';
import { PDFViewer } from '@react-pdf/renderer';

type CreditPlanPdfDebugViewProps = {
  open: boolean;
  children: JSX.Element;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const CreditPlanPdfDebugView: FC<CreditPlanPdfDebugViewProps> = ({ open, children, setOpen }) => {
  return (
    <Modal open={open} setOpen={setOpen} data-component="CreditPlanPdfDebugViewModal">
      <ModalContent title="Credit Plan PDF Test" saveButtonLabel="">
        <PDFViewer className="h-[780px] w-full">{children}</PDFViewer>
      </ModalContent>
    </Modal>
  );
};

export default CreditPlanPdfDebugView;
